import MedicalServicesTwoToneIcon from '@mui/icons-material/MedicalServicesTwoTone';
import CalendarTodayTwoToneIcon from '@mui/icons-material/CalendarTodayTwoTone';
import AccessTimeTwoToneIcon from '@mui/icons-material/AccessTimeTwoTone';

const DoctorCardMini = (props)=>{
    const row = props.selDoctor;
    let photo;
    let DefaultPhoto;
    if(row.photo !== "-" && row)
      photo = '/assets/doctor/' + row.photo;
    else
      photo = '/assets/doctor/doctorDefault.png';

   return(
    <div className="DoctorCardMini">
      <div className="top">
        <div className="photo" style={{width: '20%', backgroundImage: `url(${ photo })`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover'}}>
        </div>
        <div className="info">
          <h4>{row.name} </h4>
          <p> <MedicalServicesTwoToneIcon/>  &nbsp; {row.specialist} </p>
          <p> <CalendarTodayTwoToneIcon/> &nbsp; {props.selDate} ,&nbsp; <AccessTimeTwoToneIcon/> &nbsp; {props.selTime} </p>
        </div>
      </div>

      <div className="bottom">
            <div><div className="thead">Senin</div>  <div className="trow">{props.selDoctor.monday}</div></div>
            <div><div className="thead">Selasa</div> <div className="trow">{props.selDoctor.tuesday}</div></div>
            <div><div className="thead">Rabu</div>   <div className="trow">{props.selDoctor.wednesday}</div></div>
            <div><div className="thead">Kamis</div>  <div className="trow">{props.selDoctor.thursday}</div></div>
            <div><div className="thead">Jumat</div>  <div className="trow">{props.selDoctor.friday}</div></div>
            <div><div className="thead">Sabtu</div>  <div className="trow">{props.selDoctor.saturday}</div></div>
            <div><div className="thead">Minggu</div> <div className="trow">{props.selDoctor.sunday}</div></div>
        </div>
    </div>
    );
  }

export default DoctorCardMini;
